import * as React from 'react';
import css from './app-banner.module.scss';

export const AppBanner: React.FC = (props) => {
  return <div className={css.banner}>{props.children}</div>;
};
